import React from 'react';
import PropTypes from 'prop-types';

const FileUpload = ({
  label, name, onChange,
}) => (
  <div className="flex flex-wrap mx-3 w-full">
    <div className="flex flex-col w-full px-3 lg:mb-6">
      <label
        htmlFor={name}
        className="text-gray-400 text-sm mb-2"
      >
        {label}
        <span className="text-red-500">*</span>
      </label>

      <input type="file" id={name} onChange={onChange} className="mb-2 bg-buttons-private text-gray-300" />
    </div>
  </div>
);

export default FileUpload;

FileUpload.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
